import Form from 'react-bootstrap/Form';

function AggregatorsSearchForm({ search, searchKey, spinner }) {
  return (
    <Form.Control
      className="bo-search"
      name="search"
      id="search"
      placeholder="Search"
      noValidate
      disabled={spinner}
      defaultValue={search}
      onKeyPress={e => searchKey('aggregators', e)}
    />
  );
}

export default AggregatorsSearchForm;
